export default __webpack_public_path__ + "static/media/pin-user.5a50cae6.svg";